import React, {Component} from 'react'
import {request} from "../../../helper/APIUtils";
import {deepCopyObject, showAxiosError} from "../../../helper/helper";
import Select from "../../../local_node_modules/react-select";
import {isValidTurmobAuth2} from "../../../common/componentValidation";
import Alert from "react-s-alert";
import SweetAlert from "react-bootstrap-sweetalert";
import {AuthPageType} from "../../../helper/enums";

class TurmobModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            userList: [],
            selectedUsers: [],
            turmobList: [],
            alert: null,
            loading: false,
        };
        this.fetchTurmobTokens = this.fetchTurmobTokens.bind(this);
        this.onChange = this.onChange.bind(this);
        this.addLine = this.addLine.bind(this);
        this.saveData = this.saveData.bind(this);
        this.removeLine = this.removeLine.bind(this);
    }

    componentDidMount() {
        let userList = this.props.userList;
        this.setState({
            userList,
            loading: true,
            customer: this.props.customer
        }, () => this.fetchTurmobTokens(null, null, this.state.page, this.state.size));
    }

    async fetchTurmobTokens(accessor, direction, page, size) {
        let self = this;
        let customerId = this.props.customer.recordId;
        let params = {
            url: "/turmob/auth/findAllTokensByCustomer?page=" + page + '&size=' + size,
            method: "post",
            data: customerId
        };
        self.setState({loading: true, manual: self.manual === true ? false : self.manual});
        await request(params).then((response) => {
            let content = response.data.content;
            if(content && content.length > 0){
                self.setState({
                    selectedUsers: [...this.state.selectedUsers, ...content.map(item => item.userId)]
                })
            }
            self.setState({
                turmobList: content,
                loading: false,
                manual: false,
                page: page,
                size: size,
                total: response.data.totalElements
            });
        }).catch(function (error) {
            self.setState({manual: false, loading: false});
            showAxiosError(error);
        });

    }

    onChange(e, index) {
        let turmobList = deepCopyObject(this.state.turmobList);
        turmobList[index][e.name] = e.value;
        this.setState({turmobList});
    }

    addLine() {
        let turmobList = deepCopyObject(this.state.turmobList);
        turmobList.push({
            recordId: null,
            userId: null,
            token: null,
            customerId: this.state.customer.recordId,
        });
        this.setState({turmobList});
    }

    saveData() {
        let self = this;
        let turmobList = deepCopyObject(self.state.turmobList);
        let isValid = turmobList.every(item => isValidTurmobAuth2(item));
        if (isValid) {
            let params = {
                url: "/turmob/auth/saveTurmobAuthForUser",
                method: "post",
                data: turmobList
            };
            request(params)
                .then(function (response) {
                    if (response.data) {
                        Alert.success("Kaydetme işlemi başarılı.", {
                            position: 'top-right',
                            effect: 'stackslide',
                            timeout: 2000
                        });
                        self.setState({turmobList: response.data});
                    }
                }).catch(function (error) {
                showAxiosError(error);
            });
        } else {
            Alert.error("<strong>Token  Alanı en fazla 32 karakterle sınırlandırılmıştır. </strong><br/>", {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 2000
            });
        }
    }

    removeLine(index) {
        let turmobList = deepCopyObject(this.state.turmobList);
        let turmobIndex = turmobList[index];
        const userIdToRemove = turmobIndex.userId;

        if (turmobIndex.recordId !== null) {
            let params = {
                url: AuthPageType.TURMOB.deleteUrl,
                method: "post",
                data: turmobIndex
            };

            request(params)
                .then(response => {
                    Alert.success("TÜRMOB token bilgisi silme işlemi başarılı şekilde gerçekleşti.", {
                        position: 'top-right',
                        effect: 'stackslide',
                        timeout: 2000
                    });
                    turmobList.splice(index, 1);
                    this.setState({
                        turmobList,
                        selectedUsers: this.state.selectedUsers.filter(userId => userId !== userIdToRemove),
                        alert: null
                    });
                }).catch(function (error) {
                Alert.error("Silme işlemi gerçekleşmedi!", {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 2000
                });
                showAxiosError(error);
            });
        } else {
            turmobList.splice(index, 1);
            this.setState({
                turmobList,
                selectedUsers: this.state.selectedUsers.filter(userId => userId !== userIdToRemove),
                alert: null
            });
        }
    }

    render() {
        return (
            <div>
                <div className="card-header d-flex justify-content-between">
                    <button type="button" className="Btn ekle pull-right"
                            style={{margin: "0", background: '#3fb0ac'}}
                            onClick={() => this.addLine()}>
                    </button>
                </div>
                <div className="card-body">
                    <div className="row">
                        <div className="col-sm-12" id="turmobTable">
                            <table className="" style={{textAlign: 'center'}}>
                                <thead>
                                <tr style={{backgroundColor: '#ebedf0'}}>
                                    <th width="4%">#</th>
                                    <th width="24%">Kullanıcı Adı</th>
                                    <th width="24%">Token</th>
                                </tr>
                                </thead>
                                <tbody>
                                {this.state.turmobList && this.state.turmobList.map((item, index) =>
                                    <tr key={index}>
                                        <td data-label={"#"}>{index + 1}</td>
                                        <td data-label={"Kullanıcı Adı"}>
                                            <Select
                                                placeholder="Kullanıcı Seçiniz"
                                                value={item.userId}
                                                clearable={false}
                                                style={{width: "100%"}}
                                                noResultsText="Sonuç yok"
                                                onChange={(e) => {
                                                    if (e) {
                                                        const selectedUser = e.value;
                                                        const previousSelectedUser = item.userId;
                                                        const updatedSelectedUsers = this.state.selectedUsers.filter(userId => userId !== previousSelectedUser);
                                                        updatedSelectedUsers.push(selectedUser);
                                                        this.setState({
                                                            selectedUsers: updatedSelectedUsers
                                                        });
                                                        this.onChange({
                                                            value: e.value,
                                                            name: "userId"
                                                        }, index);
                                                    }
                                                }}
                                                options={this.state.userList
                                                    .map((user) => ({
                                                        value: user.recordId,
                                                        label: user.username,
                                                        disabled: this.state.selectedUsers.includes(user.recordId)
                                                    }))}
                                            />
                                        </td>
                                        <td data-label={"Token"}>
                                            <input type="password"
                                                   id="token"
                                                   className="form-control"
                                                   style={{
                                                       border: '1px solid grey',
                                                       fontSize: '20px',
                                                       padding: 0,
                                                       margin: 0
                                                   }}
                                                   value={item.token}
                                                   onChange={(e) => e && this.onChange({
                                                       value: e.target.value,
                                                       name: "token"
                                                   }, index)}
                                            />
                                        </td>
                                        <td data-label={"İşlemler"}>{
                                            <div style={{margin: 0, display: "table-cell"}}>
                                                <button type="button" className="Btn temizle"
                                                        style={{margin: "0", background: '#dc3545'}}
                                                        onClick={e => {
                                                            this.setState({
                                                                alert: (
                                                                    <SweetAlert showCancel warning
                                                                                confirmBtnText="Evet"
                                                                                cancelBtnText="Hayır"
                                                                                confirmBtnBsStyle="danger"
                                                                                cancelBtnBsStyle="default"
                                                                                title={"TÜRMOB token bilgisini silmek istediğize emin misiniz?"}
                                                                                onConfirm={() => this.removeLine(index)}
                                                                                onCancel={() => this.setState({alert: null})}>
                                                                    </SweetAlert>)
                                                            })
                                                        }}>

                                                </button>
                                            </div>
                                        }</td>
                                    </tr>
                                )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="" style={{float: 'right'}}>
                                <button type="button"
                                        style={{
                                            padding: '9px 39px 9px 13px',
                                            float: 'right',
                                            background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)',
                                            marginRight: '2px'
                                        }}
                                        disabled={this.state.loading}
                                        className="col-sm-21 TekBtn kaydet"
                                        onClick={this.saveData}>Kaydet
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.alert &&
                    <div className="row satirBasi">
                        {this.state.alert}
                    </div>
                }
            </div>
        )
    }
}

export default TurmobModal